<p-dialog
  *ngIf="jobOverview"
  [(visible)]="visible"
  header="Manage Task Sequence (Job: {{ jobOverview?.jobNumber }})"
  [modal]="true"
  [style]="{ width: '1000px' }"
  [closable]="true"
  (onHide)="closeDialog()"
>
  <div class="task-sequence-combine-notification" *ngIf="displayCombineNotification">
    <div class="flex grid-gap-10">
      <div class="flex-shrink-1 task-sequence-combine-notification-icon">
        <i class="fa fa-info-circle" style="color: #012169"></i>
      </div>
      <div class="flex-grow-1">
        This job has been combined. Please check the details below and set the sequence if required.
      </div>
    </div>
  </div>

  <div class="order-sequence-enable-options">
    <p-inputSwitch
      [(ngModel)]="jobOverview.orderSequencingEnabled"
      (onChange)="handleOrderSequenceToggle($event)"
      [disabled]="jobOverview?.orders.length <= 1"
      *ngIf="jobOverview"
    ></p-inputSwitch>
    <span class="toggle-label">Use specific order sequence</span>
  </div>

  <table class="task-sequence-editor-table">
    <thead>
      <tr>
        <th class="task-sequence-editor-header-cell">Type</th>
        <th class="task-sequence-editor-header-cell">Order/Task Number</th>
        <th class="task-sequence-editor-header-cell">Address</th>
        <th class="task-sequence-editor-header-cell">Sequence</th>
        <th class="task-sequence-editor-header-cell">Task Sequence</th>
        <th class="task-sequence-editor-header-cell">Move</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let order of jobOverview?.orders; let orderIndex = index">
        <tr class="task-sequence-editor-order-row">
          <td class="task-sequence-editor-row-cell" style="font-weight: bold">Order</td>
          <td class="task-sequence-editor-row-cell" style="font-weight: bold">
            {{ order.orderNumber }}
          </td>
          <td></td>
          <td class="task-sequence-editor-row-cell">
            {{ jobOverview.orderSequencingEnabled ? orderIndex + 1 : 'N/A' }}
          </td>
          <td class="task-sequence-editor-row-cell">
            <p-inputSwitch
              [(ngModel)]="order.taskSequencingEnabled"
              [disabled]="order.tasks.length <= 1"
              (onChange)="handleTaskSequenceToggle($event, order)"
            ></p-inputSwitch>
          </td>
          <td class="task-sequence-editor-row-cell">
            <div class="task-sequence-move-buttons" *ngIf="jobOverview?.orderSequencingEnabled">
              <button
                class="sort-btn"
                pButton
                icon="fa fa-angle-up"
                [disabled]="orderIndex == 0"
                (click)="moveOrderSequenceUp(orderIndex)"
              ></button>
              <button
                class="sort-btn"
                pButton
                icon="fa fa-angle-down"
                [disabled]="orderIndex + 1 == jobOverview?.orders.length"
                (click)="moveOrderSequenceDown(orderIndex)"
              ></button>
            </div>
          </td>
        </tr>
        <tr
          *ngFor="let task of order.tasks; let taskIndex = index"
          class="task-sequence-editor-task-row"
        >
          <td class="task-sequence-editor-row-cell">Task</td>
          <td class="task-sequence-editor-row-cell">{{ task.vehicleReg }}</td>
          <td class="task-sequence-editor-row-cell">
            {{ task.pickupAddress.city }} to {{ task.dropoffAddress.city }}
          </td>
          <td class="task-sequence-editor-row-cell">
            {{ order.taskSequencingEnabled ? taskIndex + 1 : 'N/A' }}
          </td>
          <td></td>
          <td class="task-sequence-editor-row-cell">
            <div class="task-sequence-move-buttons" *ngIf="order.taskSequencingEnabled">
              <button
                class="sort-btn"
                pButton
                icon="fa fa-angle-up"
                [disabled]="taskIndex == 0"
                (click)="moveTaskSequenceUp(order, taskIndex)"
              ></button>
              <button
                class="sort-btn"
                pButton
                icon="fa fa-angle-down"
                [disabled]="taskIndex + 1 == order.tasks.length"
                (click)="moveTaskSequenceDown(order, taskIndex)"
              ></button>
            </div>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>

  <p-footer>
    <button
      type="button"
      (click)="closeDialog()"
      pButton
      icon="fa ui-icon-close"
      label="Cancel"
      class="ui-button"
    ></button>
    <button
      type="button"
      icon="fa ui-icon-check"
      pButton
      label="Save"
      (click)="saveChanges()"
    ></button>
  </p-footer>
</p-dialog>
